import { useRoute } from "#imports";
import { useIsWebviewUserAgent } from "./useIsWebviewUserAgent.js";
export function useIsWebview() {
  const route = useRoute();
  return Boolean(route.meta?.isWebview) || useIsWebviewUserAgent();
}
